import cuencoS from "./img/cuencoS.jpeg"
import cuencoPetit from "./img/cuencoPetit.jpeg"
import cuencoM from "./img/cuencoM.jpeg"
import cuencoL from "./img/cuencoL.jpeg"
import cuencoXL from "./img/cuencoXL.jpeg"
import fustaBi from "./img/fustaBi.jpeg"
import fustaTri from "./img/fustaTri.jpeg"
import mateClassic from "./img/clasic.jpeg"
import mateSunset from "./img/sunset.jpeg"
import mateMara from "./img/mara.jpeg"
import mateTama from "./img/tamarindo.jpeg"
import mateMalte from "./img/malta.jpeg"
import mateSoft from "./img/soft.jpeg"
import mateMila from "./img/mila.jpeg"
import mateCler from "./img/cler.jpeg"
import tazonPerro from "./img/perro.jpeg"
import tazonConejo from "./img/conejo.jpeg"
import tazonChancho from "./img/chancho.jpeg"
import tazonGato from "./img/gato.jpeg"


const products = [
    {
        id:1,
        categoryId:"velas",
        name:"Cuenco Petit",
        description:"Contenido Neto: 45gr",
        img: cuencoPetit,
        price:"$2.500",
        stock:95
    },
    {
        id:2,
        categoryId:"velas",
        name:"Cuenco Small",
        description:"Contenido Neto: 45gr",
        img: cuencoS,
        price:"$2.500",
        stock:80
    },
    {
        id:3,
        categoryId:"velas",
        name:"Cuenco M",
        description:"Contenido Neto: 100gr",
        img: cuencoM,
        price:"$4.500",
        stock:100
    },
    {
        id:4,
        categoryId:"velas",
        name:"Cuenco L",
        description:"Contenido Neto: 135gr",
        img:cuencoL,
        price:"$6.200",
        stock:100
    },
    {
        id:5,
        categoryId:"velas",
        name:"Cuenco XL",
        description:"Contenido Neto: 280gr",
        img:cuencoXL,
        price:"$11.500",
        stock:85
    },
    {
        id:6,
        categoryId:"velas",
        name:"Fusta BI",
        description:"Contenido Neto: 55gr",
        img:fustaBi,
        price:"$4.700",
        stock:85
    },
    {
        id:7,
        categoryId:"velas",
        name:"Fusta TRI",
        description:"Contenido Neto: 80gr",
        img:fustaTri,
        price:"$5.700",
        stock:85
    },
    {
        id:8,
        categoryId:"mates",
        name:"Classic",
        description:"Mate de madera en forma desigual pintado a mano.",
        img:mateClassic,
        price:"$4.500",
        stock:80
    },
    {
        id:9,
        categoryId:"mates",
        name:"Sunset",
        description:"Mate de madera en forma cilindrica pintado a mano.",
        img:mateSunset,
        price:"$4.500",
        stock:80
    },
    {
        id:10,
        categoryId:"mates",
        name:"Mara",
        description:"Mate de madera en forma cilindrica pintado a mano.",
        img:mateMara,
        price:"$4.500",
        stock:80
    },
    {
        id:11,
        categoryId:"mates",
        name:"Tamarindo",
        description:"Mate de madera en forma cilindrica/rectangular pintado a mano.",
        img:mateTama,
        price:"$4.500",
        stock:80
    },
    {
        id:12,
        categoryId:"mates",
        name:"Malta",
        description:"Mate de madera en forma cilindrica pintado a mano.",
        img:mateMalte,
        price:"$4.500",
        stock:80
    },
    {
        id:13,
        categoryId:"mates",
        name:"Soft",
        description:"Mate de madera en forma cilindrica pintado a mano.",
        img:mateSoft,
        price:"$4.500",
        stock:80
    },
    {
        id:14,
        categoryId:"mates",
        name:"Mila",
        description:"Mate de madera en forma desigual pintado a mano.",
        img:mateMila,
        price:"$4.500",
        stock:80
    },
    {
        id:15,
        categoryId:"mates",
        name:"Cler",
        description:"Mate de madera en forma cilindrica pintado a mano.",
        img:mateCler,
        price:"$4.500",
        stock:80
    },
    {
        id:16,
        categoryId:"tazas",
        name:"Perro",
        description:"Tazon de ceramica con capacidad de 250ml",
        img:tazonPerro,
        price:"$7.000",
        stock:80
    },
    {
        id:17,
        categoryId:"tazas",
        name:"Conejo",
        description:"Tazon de ceramica con capacidad de 250ml",
        img:tazonConejo,
        price:"$7.000",
        stock:80
    },
    {
        id:18,
        categoryId:"tazas",
        name:"Chancho",
        description:"Tazon de ceramica con capacidad de 250ml",
        img:tazonChancho,
        price:"$7.000",
        stock:80
    },
    {
        id:19,
        categoryId:"tazas",
        name:"Gato",
        description:"Tazon de ceramica con capacidad de 250ml",
        img:tazonGato,
        price:"$7.000",
        stock:80
    }
]

export default products;